import React from 'react';
import { ShoppingCartIcon, UserIcon } from 'lucide-react';
export function Header() {
  return <header className="w-full" data-id="element-230">
      {/* Promotional Banner */}
      <div className="bg-orange-500 text-white text-center py-2.5 sm:py-3 px-3 sm:px-4 text-xs sm:text-sm leading-tight" data-id="element-231">
        <span className="block sm:inline" data-id="element-232">OFERTA DE LANZAMIENTO: </span>
        <span className="block sm:inline font-semibold" data-id="element-233">
          50 Recetas + Bonos Gratis por Solo $9.95 USD
        </span>
      </div>
      {/* Shipping Banner */}
      <div className="bg-gray-100 text-center py-2 sm:py-2.5 px-3 sm:px-4 text-xs sm:text-sm" data-id="element-234">
        Acceso digital instantáneo • Sin envíos • Descarga inmediata
      </div>
      {/* Main Navigation */}
      <nav className="border-b sticky top-0 bg-white z-40 shadow-sm" data-id="element-235">
        <div className="max-w-7xl mx-auto px-3 sm:px-4 py-3 sm:py-3.5 md:py-4 flex items-center justify-between" data-id="element-236">
          <div className="text-base sm:text-lg md:text-xl lg:text-2xl font-bold text-orange-600 leading-tight" data-id="element-237">
            50 Recetas Express
          </div>
          <div className="hidden md:flex items-center space-x-6 lg:space-x-8" data-id="element-238">
            <a href="#recipes-sample" className="text-gray-700 hover:text-orange-600 transition text-sm lg:text-base font-medium" data-id="element-239">
              Ver Recetas
            </a>
            <a href="#reviews" className="text-gray-700 hover:text-orange-600 transition text-sm lg:text-base font-medium" data-id="element-240">
              Testimonios
            </a>
          </div>
          <div className="flex items-center space-x-1 sm:space-x-2" data-id="element-241">
            <button className="text-gray-700 hover:text-orange-600 transition p-2 sm:p-2.5 rounded-lg hover:bg-orange-50" aria-label="Usuario" data-id="element-242">
              <UserIcon className="w-5 h-5 sm:w-5 sm:h-5" data-id="element-243" />
            </button>
            <button className="text-gray-700 hover:text-orange-600 transition p-2 sm:p-2.5 rounded-lg hover:bg-orange-50" aria-label="Carrito de compras" data-id="element-244">
              <ShoppingCartIcon className="w-5 h-5 sm:w-5 sm:h-5" data-id="element-245" />
            </button>
          </div>
        </div>
      </nav>
    </header>;
}